<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { confirmSignup } from '$lib/utils/api';
  import Loader from '$lib/components/Loader.svelte';
  
  export let code: string = '';
  
  let loading = true;
  
  onMount(async () => {
    const result = await confirmSignup(code);
    navigate(result.success ? '/signupconfirmed' : '/signupnotfound');
    loading = false;
  });
</script>

<svelte:head>
  <title>Confirming... - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  {#if loading}
    <Loader text="Confirming your signup..." />
  {/if}
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }
</style>
